import React from 'react';
import { useNavigate, useLocation, Location } from 'react-router-dom';
import { Session } from '@models/account';
import { LOGIN_PATH } from '@utils/constants/Routes';

const banMsg = `You do not have access to the system. Please contact an 
  administrator.`;
const verifyMsg = `You have been registered in the system. Please, wait
  until your account has been verified by an administrator.`;

const VerifyMsg: React.FC = () => {
    const navigate = useNavigate();
    const location: Location<Session> = useLocation();
    const goToLoginPage = () => {
        navigate(LOGIN_PATH, { replace: true });
    };

    const banned = location.state?.banned;
    const msg = banned ? banMsg : verifyMsg;

    return (
        <div>
            <p>{msg}</p>
            <button onClick={goToLoginPage} type="button">
                {'< Back'}
            </button>
        </div>
    );
};

export default VerifyMsg;
